import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import { sentEmail, sentMobileMsg, customerContactSelect } from '@/api/overseasSales/customerCenter'
import { emailValidate } from '@/utils/validate'
import type { PotentialItem } from '@/typings/api/customerCenter'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'sendLinkModel' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {

const { t } = useI18n()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const optionsMobile = ref<any>([])
const optionsEmail = ref<any>([])
const editForm = ref<any>({})
const linkmethods = [{ label: t('enum.email'), value: 'email' }]
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    try {
      const { otherTel, otherEmail } = editForm.value
      if (editForm.value.type === 'mobile') {
        await sentMobileMsg({
          cosId: editForm.value.cosId,
          mobile: otherTel ? editForm.value.mobile_other : editForm.value.mobile
        })
      } else if (editForm.value.type === 'email') {
        const email = editForm.value.email && editForm.value.email
        await sentEmail({
          cosId: editForm.value.cosId,
          email: otherEmail ? editForm.value.email_other : email
        })
      }
      loading.value = false
      message.success(t('tips.URGpwH'))
      visible.value = false
    } catch (error) {
      loading.value = false
    }
  })
}
const toggle = (rows: PotentialItem) => {
  editForm.value = {
    type: 'email',
    cosId: rows.cosId,
    customerName: rows.customerName
  }
  visible.value = true
  if (rows.cosId) {
    fetch(rows.cosId)
  }
}
// 获取联系人列表
const fetch = (cosId: string) => {
  customerContactSelect({ cosId }).then((res) => {
    optionsMobile.value = res.data.filter((item: any) => item.mobile)
    if (optionsMobile.value && optionsMobile.value.length) {
      editForm.value.mobile = optionsMobile.value[0].mobile
    }
    optionsEmail.value = res.data.filter((item: any) => item.email)
    if (optionsEmail.value && optionsEmail.value.length) {
      editForm.value.email = optionsEmail.value[0].email
    }
  })
}
// 清楚校验
const clearVaild = (type: 'mobile' | 'email') => {
  if (type === 'mobile') {
    formRef.value?.clearValidate(['mobile', 'mobile_other'])
  } else if (type === 'email') {
    formRef.value?.clearValidate(['email', 'email_other'])
  }
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_CosModal = _resolveComponent("CosModal")!

  return (_openBlock(), _createBlock(_component_CosModal, {
    visible: visible.value,
    "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((visible).value = $event)),
    title: _unref(t)('custom.sendRegistModal'),
    width: "670px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_alert, {
        message: _unref(t)('custom.sendRegistTips'),
        type: "warning",
        "show-icon": ""
      }, null, 8, ["message"]),
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: editForm.value,
            ref_key: "formRef",
            ref: formRef,
            style: {"margin-top":"10px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "customerName",
                label: _unref(t)('custom.customerName'),
                rules: [{ required: true, message: _unref(t)('common.pleaseInput') }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: editForm.value.customerName,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.customerName) = $event)),
                    disabled: true
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 8, ["label", "rules"]),
              _createVNode(_component_a_form_item, {
                name: "type",
                label: _unref(t)('custom.sendMethod'),
                rules: [{ required: true, message: _unref(t)('common.pleaseSelect') }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio_group, {
                    value: editForm.value.type,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((editForm.value.type) = $event)),
                    options: linkmethods
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 8, ["label", "rules"]),
              _createVNode(_component_a_form_item, {
                name: "email",
                label: _unref(t)('common.email'),
                rules: !editForm.value.otherEmail ? [{ required: true, message: _unref(t)('common.pleaseSelect') }] : []
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: editForm.value.email,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((editForm.value.email) = $event)),
                    placeholder: _unref(t)('common.pleaseSelect'),
                    disabled: editForm.value.otherEmail ? true : false
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsEmail.value, (item, index) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: index,
                          value: item.email
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(`${item.email}(${item.name})`), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "placeholder", "disabled"])
                ]),
                _: 1
              }, 8, ["label", "rules"]),
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_checkbox, {
                    checked: editForm.value.otherEmail,
                    "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((editForm.value.otherEmail) = $event)),
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (clearVaild('email')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('custom.useotherEmail')), 1)
                    ]),
                    _: 1
                  }, 8, ["checked"])
                ]),
                _: 1
              }),
              (editForm.value.otherEmail)
                ? (_openBlock(), _createBlock(_component_a_form_item, {
                    key: 0,
                    label: _unref(t)('custom.otherEmail'),
                    name: "email_other",
                    rules: [
            { required: true, message: _unref(t)('common.pleaseInput') },
            {
              validator: _unref(emailValidate)
            }
          ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: editForm.value.email_other,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((editForm.value.email_other) = $event)),
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label", "rules"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title", "confirmLoading"]))
}
}

})